<template>
  <v-app>
    <v-main>
      <div id="app1">
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>
<style lang="css">
::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}

::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 3px #e6e6e6;
  border-radius: 7px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a2a2a2;
}

/*****/
iframe::-webkit-scrollbar {
  width: 15px;
}

iframe::-webkit-scrollbar-track {
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}

iframe::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 3px #e6e6e6;
  border-radius: 7px;
}

iframe::-webkit-scrollbar-thumb:hover {
  background: #a2a2a2;
}
</style>
